import { Injectable } from '@angular/core';
import { RoomSelectionService } from '../room-selection.service';
import { LeadTaskService } from '../../lead-task.service';

export interface UsageSpacePreview {
  id: string;
  name: string;
  hasRoomDraft: boolean;
  translatableCategory: string;
}

export interface AllRoomsPreview {
  usageSpaces: UsageSpacePreview[];
  selfCreatedRooms: UsageSpacePreview[];
}

@Injectable()
export class RoomListService {
  constructor(
    private roomSelectionService: RoomSelectionService,
    private leadTaskService: LeadTaskService,
  ) {}

  getNgComponentOutletInputObservable() {
    return this.roomSelectionService.ngComponentOutletInput$;
  }

  startRoomExamination(id: string) {
    this.roomSelectionService.startRoomExamination(id);
  }

  getRoomListPreview(): AllRoomsPreview {
    const mapIdToPreview = (id: string) => {
      return {
        id: id,
        name: this.leadTaskService.getUsageSpaceName(id),
        hasRoomDraft: this.leadTaskService.hasRoomDraft(id),
        translatableCategory:
          this.leadTaskService.getUsageSpaceTranslatableCategory(id),
      };
    };

    const usageSpaceIds = this.leadTaskService.getUsageSpaceIds();
    const selfCreatedRoomsIds = this.leadTaskService.getSelfCreatedRoomsIds();

    return {
      usageSpaces: usageSpaceIds.map(mapIdToPreview),
      selfCreatedRooms: selfCreatedRoomsIds.map(mapIdToPreview),
    };
  }

  startCreateRoom(): void {
    this.roomSelectionService.startCreateRoom();
  }
}
